import React from 'react';
import { IoCloudOutline } from 'react-icons/io5';
import smartcardLogo from '../img/big-logo.png';
import axepayLogo from '../img/products/axepay-logo.png';

function SolutionJurny() {
  const steps = [
    {
      id: 1,
      badge: "01",
      title: "Start Here",
      subtitle: "SMKG Introduction Video",
      link: "https://youtu.be/2HvgiIsNINQ",
      className: "step-1",
      logo: <img src={smartcardLogo} alt="SmartCard" className="step-logo-img" />
    },
    {
      id: 2,
      badge: "02",
      title: "Video 2",
      subtitle: "SMKG PAAS Introduction Video",
      link: "https://youtu.be/001bZPgUqdk",
      className: "step-2",
      logo: (
        <div className="brand-logo-text">
          <IoCloudOutline className="cloud-icon" />
          SMKG PaaS
        </div>
      )
    },
    {
      id: 3,
      badge: "03",
      title: "Video 3",
      subtitle: "Axepay Introduction Video",
      link: "https://youtu.be/YKuMHQqtZsI",
      className: "step-3 light-circle",
      logo: <img src={axepayLogo} alt="AxePay" className="step-logo-img" />
    },
    {
      id: 4,
      badge: "04",
      title: "Video 4",
      subtitle: "XPAY World Introduction Video",
      link: "https://youtu.be/iJWojxM5jsI",
      className: "step-4",
      logo: (
        <div className="brand-logo-text">
          XPAY
          <span>WORLD</span>
        </div>
      )
    },
    {
      id: 5,
      badge: "05",
      title: "Video 5",
      subtitle: "XFund.Ventures Introduction Video",
      link: "https://youtu.be/eBnr_rdzl1U",
      className: "step-5",
      logo: <div className="brand-logo-text">XFund.Ventures</div>
    }
  ];

  return (
    <div className="journey-wrapper">
      <style>{`
        .journey-wrapper {
          background-color: #fafafa;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 60px 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .journey-container {
          width: 100%;
          max-width: 1100px;
          text-align: center;
          padding: 40px 20px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
        }

        /* Header Styling */
        .journey-header h2 {
          font-size: 2.2rem;
          color: #111;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .journey-header h2 span {
          color: #ff6b00;
        }

        .header-divider {
          width: 40px;
          height: 3px;
          background-color: #8b5cf6;
          margin: 0 auto 16px auto;
          border-radius: 2px;
        }

        .journey-header p {
          font-size: 1.05rem;
          color: #555;
          max-width: 500px;
          margin: 0 auto 50px auto;
          line-height: 1.5;
        }

        /* Timeline Section */
        .timeline {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          position: relative;
          flex-wrap: wrap;
        }

        .timeline::before {
          content: '';
          position: absolute;
          top: 75px;
          left: 10%;
          width: 80%;
          height: 2px;
          background: #e0e0e0;
          z-index: 1;
        }

        .timeline-item {
          position: relative;
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 18%;
          min-width: 160px;
          margin-bottom: 20px;
          text-decoration: none;
          color: inherit;
        }

        .circle-wrapper {
          position: relative;
          width: 140px;
          height: 140px;
          border-radius: 50%;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          transition: transform 0.3s ease;
        }

        .timeline-item:hover .circle-wrapper {
          transform: translateY(-5px);
        }

        .circle-wrapper::before {
          content: '';
          position: absolute;
          top: -6px;
          left: -6px;
          right: -6px;
          bottom: -6px;
          border-radius: 50%;
          border: 2px dashed var(--theme-color);
          box-sizing: border-box;
        }

        .circle-inner {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #000;
          border: 3px solid var(--theme-color);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 10px;
          position: relative;
          overflow: hidden;
        }

        .light-circle .circle-inner {
          background: #fff;
        }

        .step-logo-img {
          max-width: 82%;
          max-height: 70px;
          object-fit: contain;
          margin-bottom: 8px;
        }

        .badge {
          position: absolute;
          top: -2px;
          left: 15px;
          background: var(--theme-color);
          color: #fff;
          font-size: 0.85rem;
          font-weight: bold;
          padding: 3px 10px;
          border-radius: 12px;
          z-index: 3;
        }

        .brand-logo-text {
          color: #fff;
          font-size: 0.85rem;
          font-weight: bold;
          text-align: center;
          margin-bottom: 8px;
          line-height: 1.2;
        }

        .brand-logo-text span {
          display: block;
          font-size: 0.65rem;
          color: #aaa;
          font-weight: normal;
        }

        .cloud-icon {
          display: block;
          margin: 0 auto 4px auto;
          font-size: 1.4rem;
          color: var(--theme-color);
        }

        .play-btn {
          width: 32px;
          height: 32px;
          background: #fff;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
          transition: background 0.3s ease, transform 0.3s ease;
        }

        .light-circle .play-btn {
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          border: 1px solid #eee;
        }

        .play-btn::after {
          content: '';
          width: 0;
          height: 0;
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-left: 10px solid #000;
          margin-left: 2px;
        }

        .timeline-item:hover .play-btn {
          background: var(--theme-color);
          transform: scale(1.1);
        }

        .timeline-item:hover .play-btn::after {
          border-left-color: #fff;
        }

        .timeline-item::after {
          content: '';
          position: absolute;
          top: 72px;
          right: -10px;
          width: 8px;
          height: 8px;
          background: #fff;
          border: 2px solid var(--theme-color);
          border-radius: 50%;
          z-index: 2;
        }

        .timeline-item:last-child::after {
          display: none;
        }

        .item-title {
          font-size: 1rem;
          font-weight: bold;
          color: var(--theme-color);
          margin-bottom: 4px;
        }

        .item-subtitle {
          font-size: 0.85rem;
          color: #333;
          font-weight: 600;
        }

        .underline {
          width: 30px;
          height: 2px;
          background-color: var(--theme-color);
          margin: 6px auto 0 auto;
          border-radius: 2px;
        }

        /* Color Themes */
        .step-1 { --theme-color: #ff6b00; }
        .step-2 { --theme-color: #8b5cf6; }
        .step-3 { --theme-color: #e53e3e; }
        .step-4 { --theme-color: #0052cc; }
        .step-5 { --theme-color: #14b8a6; }

        /* Info Bar */
        .info-bar {
          display: flex;
          align-items: center;
          gap: 12px;
          margin: 30px auto 0 auto;
          max-width: 780px;
          padding: 14px 26px;
          border: 1px solid #d9c9fb;
          border-radius: 40px;
          background: #faf8ff;
        }

        .info-icon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #8b5cf6;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.75rem;
          font-style: italic;
          font-weight: bold;
        }

        .info-bar p {
          margin: 0;
          text-align: left;
          font-size: 0.9rem;
          color: #333;
          line-height: 1.4;
        }

        .info-link {
          color: #8b5cf6;
          font-weight: 700;
        }

        @media (max-width: 900px) {
          .timeline {
            flex-direction: column;
            align-items: center;
          }

          .timeline::before {
            top: 0;
            bottom: 0;
            left: 50%;
            width: 2px;
            height: 100%;
          }

          .timeline-item {
            width: 100%;
            margin-bottom: 40px;
          }

          .timeline-item::after {
            display: none;
          }

          .info-bar {
            flex-direction: column;
            text-align: center;
            border-radius: 20px;
          }

          .info-bar p {
            text-align: center;
          }
        }
      `}</style>

      <div className="journey-container">
        {/* Header */}
        <div className="journey-header">
          <h2>Our <span>Solution</span> Journey</h2>
          <div className="header-divider"></div>
          <p>Explore our ecosystem through a connected journey of five key solutions videos.</p>
        </div>

        {/* Timeline Steps */}
        <div className="timeline">
          {steps.map((step) => (
            <a
              key={step.id}
              href={step.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`timeline-item ${step.className}`}
            >
              <div className="badge">{step.badge}</div>
              <div className="circle-wrapper">
                <div className="circle-inner">
                  {step.logo}
                  <div className="play-btn"></div>
                </div>
              </div>
              <div className="item-title">{step.title}</div>
              <div className="item-subtitle">{step.subtitle}</div>
              <div className="underline"></div>
            </a>
          ))}
        </div>

        {/* Info Bar */}
        <div className="info-bar">
          <span className="info-icon">i</span>
          <p>
            Clicking any Play button will open the respective video directly on the official{' '}
            <span className="info-link">SMKG YouTube channel</span> in a new browser tab.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SolutionJurny
